const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Load More posts
 */
const LoadMorePosts = {

    // 1. describe and create/initiate our object
    init() { 
        this.loadMoreContainer = $('#load-more-container');
        this.loadMoreButton = $('#load-more-btn');
        this.postGrid = $('#post-grid');
        this.postType = $('#post-type').val();
        this.totalPosts = $('#post-count').val();
        this.templatePartDir = $('#template-part-dir').val();
        this.currentPageNumber = 2;
        this.events();
    },

    // 2. events
    events() {
        this.loadMoreButton.on('click', this.loadPosts.bind(this));
    },

    // 3. methods (function, action..)
    loadPosts(e) {
        // UI Loader
        this.loadMoreButton.html(`
            <svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-guard-red" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" stroke="rgba(243, 244, 246,1)" stroke-width="4"></circle>
                <path fill="#152A4A" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>Loading...</span>
        `);
    
        // Get "this" of the loadPost object rather than the jqXHR object inside the $.post
        const self = this;
       
        // Calculate the total number of pages
        const totalPages = Math.ceil(this.totalPosts / 6);
   
        // load_more_post() & fade in the data
        e.preventDefault();
        const data = {
            action: 'load_more_posts',
            page: self.currentPageNumber,
            part_dir: self.templatePartDir,
            post_type: self.postType,
            nonce: load_more.nonce,
        };
        console.log(data);
        $.post(load_more.ajax_url, data)
            .done(function(response) {
                const newPosts = $(response).hide();
                self.postGrid.append(newPosts);
                newPosts.fadeIn();
                
                self.currentPageNumber++;
    
                // Hide the Load More container when all posts have been loaded or return our original text
                if (self.currentPageNumber > totalPages) {
                    self.loadMoreContainer.remove();
                } else {
                    self.loadMoreButton.text('Load More');
                }
            })
            .fail(function(xhr, textStatus, error) {
                console.log(`${xhr.statusText}: ${textStatus}: ${error}`);
            });
    }

};

export default LoadMorePosts;